
<div class="why-oa-container">
  <div class="title-3x">Why Outdoor Access?</div>
  <div class="why-oa-image-container">
    <div class="why-oa-flx-card-container">
      @for (card of whyOACard; track card) {
        <div>
          <div class="why-oa-card">
            <div class="why-oa-card-title">{{card.title}}</div>
            <div class="why-oa-card-content">{{card.content}}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>


